<div [ngClass]="{'readonly': readonly}">
    <tag-input matInput
                class="facility"
                [(ngModel)]="currentBuiltinFittings"
                [identifyBy]="'id'"
                [displayBy]="'name'"
                (onRemove)="tagRemove($event)"
                (click)="chooseBuiltinFittings()"
                [placeholder]="getPlaceholder()"
                [secondaryPlaceholder]="getPlaceholder()"
                readonly="true">
    </tag-input>
</div>